import isInKwaiying from '../isInKwaiying';
/**
 * 当前所在 app名
 * 'wechat' || 'kwai' || 'qq' ...
 */
export default function getAppName() {
    if (isInKwaiying()) {
        return 'kwaiying';
    }
    const ua = navigator.userAgent;
    const appRules = {
        qq: /\bQQ\b/,
        // 快手app
        kwai: / (Kwai|Kwai_Lite|Kwai_Pro|livemate|ksthanos|ksNebula|kswv)\//,
        wechat: /\bMicroMessenger\b/,
        weibo: /\bWeibo\b/,
        qzone: /\bQzone\b/,
        // 腾讯浏览服务(Tencent Browser Service) 简称TBS
        // tbs: /\bTBS\b/,
        // 手机QQ浏览器
        // qqBrowser: /\bMQQBrowser\b/,
        // 手机百度
        baidu: /\bbaiduboxapp\b/,
        uc: /\bUCBrowser\b/,
    };
    /**
     * 获取当前所在 app名
     * return 'wechat' || 'kwai' || 'qq' ...
     */
    for (const key in appRules) {
        // @ts-expect-error
        const rule = appRules[key];
        if (rule.test(ua)) {
            return key;
        }
    }
    return 'UNKNOWN';
}
